import React from "react";

export default (props) => <nav className="navigation"></nav>;
